import { message } from 'antd'
import useFetch from 'elements/Hooks/useFetch'
import { TimesheetsApi } from '../../../../api/People/Timesheets'
import TimesheetLines from '../../../../components/People/Timesheet/Lines/TimesheetLines'
import React from 'react'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useModalData from '../../../../elements/Hooks/useModalData'

function TimesheetLinesCont(props) {
  const { timesheet } = props

  const { data: list, fetching, fetch } = useFetch({ url: `timesheet/lines/${timesheet._key}` })

  const {
    visible,
    modalType,
    object: line,
    submitting,
    setSubmitting,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
  } = useModalData(undefined, TimesheetsApi.lines.update, TimesheetsApi.lines.remove, fetch)

  async function submit() {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await TimesheetsApi.lines.create({
        ...newObject,
        timesheet: timesheet._key,
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <TimesheetLines
      {...{
        list,
        fetching,
        fetch,
        visible,
        submitting,
        timesheet,
        line,
        onShow,
        onCancel,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
      }}
    />
  )
}

TimesheetLinesCont.propTypes = {}
TimesheetLinesCont.defaultProps = {}

export default TimesheetLinesCont
